/* Tansy Active · "Find your size" (Eric, 04/11/2026). Gaveta lateral de 3 passos: altura e peso (com o tamanho
   estimado ao vivo), formato do corpo e caimento. O tamanho sai da tabela do próprio produto (custom.size_guide):
   - tabela de medidas do corpo (o guia geral, "general": true): o primeiro tamanho em que busto, cintura e quadril
     cabem no limite de cima da faixa;
   - tabela de medidas da peça (sem esticar): a medida da peça não dá para comparar direto com o corpo (legging de
     compressão mede bem menos que o corpo; moletom, mais). Cada medida da tabela é calibrada pela tabela-padrão dos
     EUA (a mediana de peça ÷ corpo-padrão nos tamanhos dela) e o tamanho sai da progressão da própria tabela.
     "Runs small" na nota soma 1 polegada. Medida "flat" vale o dobro.
   - tabela sem busto, cintura nem quadril (só comprimento): tabela-padrão dos EUA, como estimativa.
   As medidas do corpo saem da altura e do peso (fórmula pelo IMC, só uma estimativa) e mudam com o formato do corpo.
   O perfil fica só neste aparelho (localStorage "tansy-tamanho"). Nenhum dado sai do navegador.
   Solta o evento "tansy:seu" {tam, aplicar} no <tansy-tamanho>: quem desenha os tamanhos marca o tamanho. */
(() => {
  if (customElements.get('tansy-tamanho')) return;
  const CHAVE = 'tansy-tamanho';
  const ler = () => { try { return JSON.parse(localStorage.getItem(CHAVE)) || null; } catch (e) { return null; } };
  const gravar = (p) => { try { localStorage.setItem(CHAVE, JSON.stringify(p)); } catch (e) { /* aba privada: vale só agora */ } };

  // busto, cintura e quadril do corpo (limite de cima, em polegadas) da tabela-padrão feminina dos EUA
  const PADRAO = { XS: [32, 25, 35], S: [34, 27, 37], M: [36, 29, 39], L: [39, 32, 42], XL: [42, 35, 45],
    XXL: [45, 38, 48], '3XL': [48, 41, 51], '4XL': [51, 44, 54], '5XL': [54, 47, 57] };
  const norm = (t) => String(t).trim().toUpperCase().replace(/^2XL$/, 'XXL').replace(/^XXXL$/, '3XL').replace(/^1XL$/, 'XL');
  const SOLTA = /hoodie|jacket|sweatshirt|pullover|zip|coat|jogger|loose|wide|oversized|sweatpant|tee\b|t-shirt|relaxed|fleece-lined pullover/i;

  function corpo(p) {
    const bmi = p.w / Math.pow(p.h / 100, 2);
    let busto = (1.9 * bmi + 45) / 2.54, cint = (2.3 * bmi + 18) / 2.54, quad = (2.0 * bmi + 50) / 2.54;
    if (p.forma === 'reta') { cint *= 1.04; quad *= 0.97; }
    if (p.forma === 'curvas') { quad *= 1.04; cint *= 0.97; }
    if (p.forma === 'busto') busto *= 1.06;
    const folga = p.caimento === 'justo' ? -0.75 : p.caimento === 'solto' ? 1 : 0;
    return { busto: busto + folga, cint: cint + folga, quad: quad + folga };
  }

  const num = (s) => { const n = String(s).match(/\d+(\.\d+)?/g); return n ? n.map(Number) : null; };
  function qualMedida(nome) {
    const n = nome.toLowerCase();
    if (/length|hem|sleeve|inseam|rise|shoulder|thigh/.test(n)) return null;
    if (/bust|chest/.test(n)) return 'busto';
    if (/waist/.test(n)) return 'cint';
    if (/hip/.test(n)) return 'quad';
    return null;
  }

  function medida(r, col) {
    const v = num(r[col.i]); if (!v) return 0;
    let g = v.reduce((a, b) => a + b, 0) / v.length;
    if (col.flat || g < (col.m === 'busto' ? 22 : 18)) g *= 2;
    return g;
  }
  // devolve {tam, base: 'peca' | 'geral' | 'padrao'} para um produto e um perfil
  function calcular(d, p) {
    const tams = d.tams || [];
    if (tams.length <= 1) return { tam: tams[0] || '', base: 'padrao' };
    const c = corpo(p);
    const tipo = (d.tipo || '') + ' ' + (d.titulo || '');
    const baixo = /legging|short|skort|jogger|pant|skirt/i.test(tipo) && !/set|jumpsuit/i.test(tipo);
    const cima = /top|bra|hoodie|jacket|sleeve|pullover|sweatshirt|tank|tee/i.test(tipo) && !/set|jumpsuit/i.test(tipo);
    const usa = (m) => (baixo ? m !== 'busto' : cima ? m === 'busto' : true);
    const t = d.tabela;
    const meus = (lista) => tams.filter((x) => lista.some((y) => norm(y) === norm(x)));
    if (t && Array.isArray(t.columns) && Array.isArray(t.rows)) {
      const cols = t.columns.map((nome, i) => ({ i, m: qualMedida(String(nome)), flat: /flat/i.test(nome) })).filter((x) => x.m && usa(x.m));
      const linhas = t.rows.filter((r) => tams.some((x) => norm(x) === norm(r[0])));
      if (cols.length && linhas.length && (t.general || linhas.some((r) => PADRAO[norm(r[0])]))) {
        const apertado = !t.general && /runs small/i.test(t.note || '') ? 1 : 0;
        const IDX = { busto: 0, cint: 1, quad: 2 };
        // calibra cada medida da peça pela tabela-padrão (sem calibração possível, a medida sai da conta)
        for (const col of cols) {
          if (t.general) { col.k = 1; continue; }
          const q = linhas.filter((r) => PADRAO[norm(r[0])] && medida(r, col)).map((r) => medida(r, col) / PADRAO[norm(r[0])][IDX[col.m]]).sort((a, b) => a - b);
          col.k = q.length ? q[Math.floor(q.length / 2)] : 0;
        }
        cols.splice(0, cols.length, ...cols.filter((col) => col.k));
        if (cols.length) for (const r of linhas) {
          const ok = cols.every((col) => {
            const v = num(r[col.i]); if (!v) return true;
            if (t.general) return v[v.length - 1] + 0.25 >= c[col.m];
            return medida(r, col) / col.k + 0.25 >= c[col.m] + apertado;
          });
          if (ok) return { tam: tams.find((x) => norm(x) === norm(r[0])), base: t.general ? 'geral' : 'peca' };
        }
        const ult = linhas[linhas.length - 1][0];
        if (cols.length)         return { tam: tams.find((x) => norm(x) === norm(ult)), base: t.general ? 'geral' : 'peca', acima: true };
      }
    }
    const pad = meus(Object.keys(PADRAO));
    const lista = tams.filter((x) => PADRAO[norm(x)]);
    if (!lista.length) return { tam: tams[Math.floor(tams.length / 2)], base: 'padrao' };
    for (const x of lista) {
      const [b, w, h] = PADRAO[norm(x)];
      if ((!usa('busto') || c.busto <= b + 0.25) && (!usa('cint') || c.cint <= w + 0.25) && (!usa('quad') || c.quad <= h + 0.25)) return { tam: x, base: 'padrao' };
    }
    return { tam: pad[pad.length - 1] || lista[lista.length - 1], base: 'padrao', acima: true };
  }

  // ---------- gaveta (uma só na página) ----------
  let gaveta, atual, rascunho;
  const ALT = [140, 200], PESO = [40, 150];
  const pes = (cm) => { const pol = Math.round(cm / 2.54); return `${Math.floor(pol / 12)}′${pol % 12}″`; };
  const SVG = {
    reta: '<svg viewBox="0 0 40 64" aria-hidden="true"><path d="M13 6h14M12 6c-1 10-1 18 0 26M28 6c1 10 1 18 0 26M12 32c0 10 0 18 1 28M28 32c0 10 0 18-1 28"/></svg>',
    curvas: '<svg viewBox="0 0 40 64" aria-hidden="true"><path d="M13 6h14M13 6c-1 8 2 14 2 18s-6 8-6 14M27 6c1 8-2 14-2 18s6 8 6 14M9 38c0 8 2 14 4 22M31 38c0 8-2 14-4 22"/></svg>',
    busto: '<svg viewBox="0 0 40 64" aria-hidden="true"><path d="M11 6h18M11 6c-3 6-3 12 0 16s3 6 3 10M29 6c3 6 3 12 0 16s-3 6-3 10M14 32c0 10 0 18 1 28M26 32c0 10 0 18-1 28"/></svg>'
  };
  function montar() {
    gaveta = document.createElement('div');
    gaveta.className = 'ttg'; gaveta.hidden = true;
    gaveta.innerHTML = `
      <div class="ttg__fundo" data-fechar></div>
      <aside class="ttg__caixa" role="dialog" aria-modal="true" aria-labelledby="ttg-titulo">
        <header class="ttg__cab">
          <p class="ttg__marca" id="ttg-titulo">Find your perfect size</p>
          <button type="button" class="ttg__x" data-fechar aria-label="Close">×</button>
        </header>
        <div class="ttg__barra"><i data-barra></i></div>
        <p class="ttg__passo" data-passo></p>
        <section data-p="1">
          <h2 class="ttg__h">Let's find your fit</h2>
          <p class="ttg__sub">Two measurements are all it takes. Drag to adjust.</p>
          <div class="ttg__medida">
            <div class="ttg__linha"><span>Height</span><b data-alt-txt></b>
              <span class="ttg__un" role="group" aria-label="Height unit"><button type="button" data-un-alt="cm">cm</button><button type="button" data-un-alt="ft">ft/in</button></span></div>
            <input type="range" min="${ALT[0]}" max="${ALT[1]}" step="1" data-alt aria-label="Height">
          </div>
          <div class="ttg__medida">
            <div class="ttg__linha"><span>Weight</span><b data-peso-txt></b>
              <span class="ttg__un" role="group" aria-label="Weight unit"><button type="button" data-un-peso="kg">kg</button><button type="button" data-un-peso="lb">lbs</button></span></div>
            <input type="range" min="${PESO[0]}" max="${PESO[1]}" step="0.5" data-peso aria-label="Weight">
          </div>
          <div class="ttg__ao-vivo"><svg class="ttg__fig" viewBox="0 0 60 120" aria-hidden="true"><path data-fig/></svg><div><span>Live estimate</span><b data-ao-vivo></b></div></div>
        </section>
        <section data-p="2" hidden>
          <h2 class="ttg__h">Your body shape</h2>
          <p class="ttg__sub">Pick the one closest to you. It fine-tunes the estimate.</p>
          <div class="ttg__ops" data-grupo="forma">
            <button type="button" data-v="reta">${SVG.reta}<b>Straight</b><span>Bust, waist and hips about the same</span></button>
            <button type="button" data-v="curvas">${SVG.curvas}<b>Curvy</b><span>Fuller hips and thighs</span></button>
            <button type="button" data-v="busto">${SVG.busto}<b>Fuller bust</b><span>Bust fuller than hips</span></button>
          </div>
        </section>
        <section data-p="3" hidden>
          <h2 class="ttg__h">How do you like it to fit?</h2>
          <p class="ttg__sub">The same piece can feel very different.</p>
          <div class="ttg__ops ttg__ops--fit" data-grupo="caimento">
            <button type="button" data-v="justo"><b>Snug</b><span>Close to the skin, extra hold</span></button>
            <button type="button" data-v="corpo"><b>True to body</b><span>Fitted, the way it's designed</span></button>
            <button type="button" data-v="solto"><b>Relaxed</b><span>A little more room to move</span></button>
          </div>
        </section>
        <section data-p="4" hidden>
          <p class="ttg__sub">Your size in <span data-res-nome></span></p>
          <p class="ttg__res" data-res-tam></p>
          <p class="ttg__base" data-res-base></p>
          <p class="ttg__alerta" data-res-alerta hidden></p>
          <div class="ttg__resumo" data-res-resumo></div>
          <p class="ttg__priv">Saved privately on this device, so every piece shows your size.</p>
        </section>
        <footer class="ttg__pe">
          <button type="button" class="ttg__voltar" data-voltar>Back</button>
          <button type="button" class="ttg__seguir" data-seguir>Continue</button>
        </footer>
      </aside>`;
    document.body.appendChild(gaveta);
    const $ = (s) => gaveta.querySelector(s);
    gaveta.querySelectorAll('[data-fechar]').forEach((b) => b.addEventListener('click', fechar));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !gaveta.hidden) fechar(); });
    $('[data-alt]').addEventListener('input', (e) => { rascunho.h = +e.target.value; pintar(); });
    $('[data-peso]').addEventListener('input', (e) => { rascunho.w = +e.target.value; pintar(); });
    gaveta.querySelectorAll('[data-un-alt]').forEach((b) => b.addEventListener('click', () => { rascunho.unAlt = b.dataset.unAlt; pintar(); }));
    gaveta.querySelectorAll('[data-un-peso]').forEach((b) => b.addEventListener('click', () => { rascunho.unPeso = b.dataset.unPeso; pintar(); }));
    gaveta.querySelectorAll('[data-grupo] button').forEach((b) => b.addEventListener('click', () => { rascunho[b.parentElement.dataset.grupo] = b.dataset.v; pintar(); }));
    $('[data-voltar]').addEventListener('click', () => { if (rascunho.passo === 4) rascunho.passo = 1; else rascunho.passo = Math.max(1, rascunho.passo - 1); pintar(); });
    $('[data-seguir]').addEventListener('click', seguir);
  }
  function boneco(h, w) {
    const bmi = w / Math.pow(h / 100, 2), k = Math.max(0.75, Math.min(1.45, bmi / 22)), alt = 70 + ((h - ALT[0]) / (ALT[1] - ALT[0])) * 40;
    const y0 = 118 - alt, u = alt / 100, x = (v) => (30 + v * k).toFixed(1), y = (v) => (y0 + v * u).toFixed(1);
    return `M30 ${y(0)}a${(6 * u).toFixed(1)} ${(6 * u).toFixed(1)} 0 1 0 .01 0 M${x(-6)} ${y(16)}C${x(-12)} ${y(22)} ${x(-9)} ${y(34)} ${x(-7)} ${y(42)}S${x(-12)} ${y(54)} ${x(-11)} ${y(60)}L${x(-6)} ${y(100)} M${x(6)} ${y(16)}C${x(12)} ${y(22)} ${x(9)} ${y(34)} ${x(7)} ${y(42)}S${x(12)} ${y(54)} ${x(11)} ${y(60)}L${x(6)} ${y(100)} M30 ${y(62)}L30 ${y(100)}`;
  }
  const NOMES = { reta: 'Straight', curvas: 'Curvy', busto: 'Fuller bust', justo: 'Snug', corpo: 'True to body', solto: 'Relaxed' };
  function pintar() {
    const $ = (s) => gaveta.querySelector(s), r = rascunho, d = atual.dados;
    gaveta.querySelectorAll('section[data-p]').forEach((s) => { s.hidden = +s.dataset.p !== r.passo; });
    $('[data-passo]').textContent = r.passo <= 3 ? `0${r.passo} / 03` : 'Your result';
    $('[data-barra]').style.width = `${(Math.min(r.passo, 3) / 3) * 100}%`;
    $('[data-alt]').value = r.h; $('[data-peso]').value = r.w;
    $('[data-alt-txt]').textContent = r.unAlt === 'ft' ? pes(r.h) : `${r.h} cm`;
    $('[data-peso-txt]').textContent = r.unPeso === 'lb' ? `${Math.round(r.w * 2.2046)} lbs` : `${Math.round(r.w)} kg`;
    gaveta.querySelectorAll('[data-un-alt]').forEach((b) => b.classList.toggle('is-on', b.dataset.unAlt === r.unAlt));
    gaveta.querySelectorAll('[data-un-peso]').forEach((b) => b.classList.toggle('is-on', b.dataset.unPeso === r.unPeso));
    gaveta.querySelectorAll('[data-grupo] button').forEach((b) => { const on = r[b.parentElement.dataset.grupo] === b.dataset.v; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
    $('[data-fig]').setAttribute('d', boneco(r.h, r.w));
    $('[data-ao-vivo]').textContent = calcular(d, { ...r, forma: r.forma || '', caimento: 'corpo' }).tam;
    const precisa = r.passo === 2 ? r.forma : r.passo === 3 ? r.caimento : true;
    $('[data-seguir]').disabled = !precisa;
    $('[data-seguir]').textContent = r.passo === 3 ? 'See my size' : r.passo === 4 ? `Select size ${calcular(d, r).tam}` : 'Continue';
    $('[data-voltar]').hidden = r.passo === 1;
    $('[data-voltar]').textContent = r.passo === 4 ? 'Start over' : 'Back';
    if (r.passo === 4) {
      const res = calcular(d, r);
      $('[data-res-nome]').textContent = d.titulo;
      $('[data-res-tam]').textContent = res.tam;
      $('[data-res-base]').textContent = res.base === 'peca' ? "Based on this piece's measurements. It's an estimate, so check the size guide if you are between sizes."
        : res.base === 'geral' ? 'Estimated from our general size guide. If you are between sizes, size up.'
        : 'Estimated from standard US sizing. If you are between sizes, size up.';
      $('[data-res-resumo]').innerHTML = [r.unAlt === 'ft' ? pes(r.h) : `${r.h} cm`, r.unPeso === 'lb' ? `${Math.round(r.w * 2.2046)} lbs` : `${Math.round(r.w)} kg`, NOMES[r.forma], NOMES[r.caimento]]
        .map((t) => `<span>${t}</span>`).join('') + '<button type="button" data-editar>Edit</button>';
      $('[data-editar]').addEventListener('click', () => { r.passo = 1; pintar(); });
      const cor = atual.el.dataset.cor || '';
      const temCor = d.v.some((v) => v[0] === res.tam && (!cor || v[1] === cor) && v[2]);
      const temAlguma = d.v.some((v) => v[0] === res.tam && v[2]);
      const a = $('[data-res-alerta]');
      a.hidden = temCor && !res.acima;
      a.textContent = res.acima ? `${res.tam} is the largest size of this piece and may feel snug.`
        : !temAlguma ? `${res.tam} is sold out right now.` : `${res.tam} is sold out in ${cor}. Try another color.`;
    }
  }
  function seguir() {
    const r = rascunho;
    if (r.passo < 3) { r.passo += 1; pintar(); return; }
    if (r.passo === 3) {
      r.passo = 4;
      gravar({ h: r.h, w: r.w, forma: r.forma, caimento: r.caimento, unAlt: r.unAlt, unPeso: r.unPeso });
      pintar();
      document.querySelectorAll('tansy-tamanho').forEach((el) => el.atualizar(el === atual.el));
      return;
    }
    atual.el.atualizar(true, true);
    fechar();
  }
  function abrir(el) {
    if (!gaveta) montar();
    atual = el;
    const salvo = ler();
    const us = (navigator.language || '').toLowerCase() === 'en-us';
    rascunho = { h: 165, w: 62, forma: '', caimento: '', unAlt: us ? 'ft' : 'cm', unPeso: us ? 'lb' : 'kg', ...(salvo || {}), passo: salvo ? 4 : 1 };
    gaveta.hidden = false;
    document.documentElement.classList.add('ttg-aberta');
    requestAnimationFrame(() => gaveta.classList.add('is-aberta'));
    pintar();
    gaveta.querySelector(salvo ? '[data-seguir]' : '[data-alt]').focus({ preventScroll: true });
  }
  function fechar() {
    gaveta.classList.remove('is-aberta');
    document.documentElement.classList.remove('ttg-aberta');
    setTimeout(() => { gaveta.hidden = true; }, 250);
    atual?.el.querySelector('[data-tt-abrir]')?.focus({ preventScroll: true });
  }

  customElements.define('tansy-tamanho', class extends HTMLElement {
    connectedCallback() {
      try { this.dados = JSON.parse(this.querySelector('[data-tt]').textContent); } catch (e) { return; }
      this.el = this;
      this.querySelector('[data-tt-abrir]').addEventListener('click', () => abrir(this));
      this.atualizar(false);
    }
    // escreve "Your size: M" no botão e avisa quem desenha os tamanhos; aplicar = a cliente pediu para marcar
    atualizar(avisar = true, aplicar = false) {
      const p = ler();
      const rot = this.querySelector('[data-tt-rotulo]');
      if (!p || !p.forma) { rot.textContent = 'Find your size'; delete this.dataset.seu; return; }
      const res = calcular(this.dados, p);
      this.dataset.seu = res.tam;
      rot.innerHTML = `Your size: <b>${res.tam}</b>`;
      if (avisar || !this.avisado) {
        this.avisado = true;
        this.dispatchEvent(new CustomEvent('tansy:seu', { bubbles: true, detail: { tam: res.tam, aplicar } }));
      }
    }
  });
})();
